import { render } from "./PermisosSection.vue?vue&type=template&id=32351a98"
import script from "./PermisosSection.vue?vue&type=script&lang=js"
export * from "./PermisosSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__